"use strict";

exports.__esModule = true;
exports.DataItemFormGroup = DataItemFormGroup;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _DataItemChartSelectorAdaptor = require("../../DataItemChart/DataItemChartSelectorAdaptor");
var _Core = require("../../../Core");
var _MultiFieldSelector = require("../../../Recharts/Fields/MultiFieldSelector/MultiFieldSelector");
var _DataItemPopoverContent = require("./DataItemPopoverContent");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var MAXIMUM_ALLOWED_DATA_ITEMS = 4;
function DataItemFormGroup(props) {
  var _useContext = (0, _react.useContext)(_Core.TranslatorContext),
    translate = _useContext.translate;
  var isMultiSelector = props.isMultiSelector,
    device = props.device,
    allowedCategories = props.allowedCategories,
    items = props.items,
    dataItemValues = props.dataItemValues,
    setDataItemValues = props.setDataItemValues,
    colorSelector = props.colorSelector,
    _props$enableAddingNe = props.enableAddingNewItem,
    enableAddingNewItem = _props$enableAddingNe === void 0 ? true : _props$enableAddingNe;
  if (isMultiSelector) {
    return /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
      label: translate("DataItemPopoverContent.selectMulti.info", "Select Data Items"),
      style: {
        margin: "0 auto",
        overflow: "auto",
        padding: "20px",
        paddingBottom: "0px"
      }
    }, /*#__PURE__*/_react["default"].createElement(_MultiFieldSelector.MultiFieldSelector, {
      getKey: function getKey(input) {
        return input.dataItemName;
      },
      renderItemText: function renderItemText(input) {
        return input.dataItemName;
      },
      itemPredicate: function itemPredicate(query, _ref) {
        var dataItemName = _ref.dataItemName;
        var q = query.toLowerCase();
        return (dataItemName == null ? void 0 : dataItemName.toLowerCase().indexOf(q)) !== -1;
      },
      selectedItems: dataItemValues,
      onChange: function onChange(selectedValues) {
        setDataItemValues(selectedValues);
      },
      colorSelector: colorSelector,
      items: items,
      addItem: (dataItemValues == null ? void 0 : dataItemValues.length) < MAXIMUM_ALLOWED_DATA_ITEMS,
      enableAddingNewItem: enableAddingNewItem,
      width: 200
    }));
  }
  return /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: translate("DataItemPopoverContent.selectSingle.info", "Select Data Item"),
    style: {
      margin: "0 auto 10px",
      overflow: "auto",
      padding: "15px 20px",
      paddingBottom: "0px"
    }
  }, /*#__PURE__*/_react["default"].createElement(_DataItemChartSelectorAdaptor.DataItemChartSelectorAdaptor, {
    dataTestId: "DataItemPopoverContent.singleDataItem.selector"
    // Pass a string name so the adaptor can resolve the stats object for
    // Selector button text. Passing `["avail"]` left selected as a bare
    // string and renderItemText(selected[0]).dataItemName was undefined
    // (empty button — fails Cypress `.contains("avail")` under React 18).
    ,
    value: dataItemValues.length > 0 ? dataItemValues[0] : "",
    onChange: function onChange(value) {
      setDataItemValues(value ? Array.isArray(value) ? [value[0].dataItemName] : [value] : []);
    },
    devices: [device],
    renderItemLabel: function renderItemLabel() {},
    allowedCategories: allowedCategories,
    width: 200,
    style: {
      marginTop: "3px"
    }
  }));
}